import {
  Box,
  Text,
  Image,
  Center,
  VStack,
  SimpleGrid,
  Flex,
  useBreakpointValue,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Button,
  useToast,
} from "@chakra-ui/react";
import { Field, Form, Formik, FormikErrors } from "formik";
import { isPhone } from "@/utils/utils";

import bannerBg from "@/assets/images/companybg.png";
import bgImg from "@/assets/images/company_list_bg.png";
import companyImg1 from "@/assets/images/companyimg1.png";
import companyImg2 from "@/assets/images/companyimg2.png";
import companyImg3 from "@/assets/images/companyimg3.png";
import companyImg4 from "@/assets/images/companyimg4.png";
import companyImg5 from "@/assets/images/companyimg5.png";
import qyLogo1 from "@/assets/images/qylogo1.png";
import qyLogo2 from "@/assets/images/qylogo2.png";
import qyLogo3 from "@/assets/images/qylogo3.png";
import qyLogo4 from "@/assets/images/qylogo4.png";
import qyLogo5 from "@/assets/images/qylogo5.png";
import qyLogo6 from "@/assets/images/qylogo6.png";
import qyLogo7 from "@/assets/images/qylogo7.png";
import qyLogo8 from "@/assets/images/qylogo8.png";
import qyLogo9 from "@/assets/images/qylogo9.png";
import qyLogo10 from "@/assets/images/qylogo10.png";
import qyLogo11 from "@/assets/images/qylogo11.png";
import qyLogo12 from "@/assets/images/qylogo12.png";
import qyLogo13 from "@/assets/images/qylogo13.png";
import qyLogo14 from "@/assets/images/qylogo14.png";
import qyLogo15 from "@/assets/images/qylogo15.png";
import qyLogo16 from "@/assets/images/qylogo16.png";
import qyLogo17 from "@/assets/images/qylogo17.png";
import qyLogo18 from "@/assets/images/qylogo18.png";
import qyLogo19 from "@/assets/images/qylogo19.png";
import qyLogo20 from "@/assets/images/qylogo20.png";
import qyLogo21 from "@/assets/images/qylogo21.png";
import qyLogo22 from "@/assets/images/qylogo22.png";
import qyLogo23 from "@/assets/images/qylogo23.png";
import qyLogo24 from "@/assets/images/qylogo24.png";
import qyLogo25 from "@/assets/images/qylogo25.png";
import qyLogo26 from "@/assets/images/qylogo26.png";
import qyLogo27 from "@/assets/images/qylogo27.png";
import qyLogo28 from "@/assets/images/qylogo28.png";
import qyLogo29 from "@/assets/images/qylogo29.png";
import qyLogo30 from "@/assets/images/qylogo30.png";
import qyLogo31 from "@/assets/images/qylogo31.png";
import qyLogo32 from "@/assets/images/qylogo32.png";
import qyLogo33 from "@/assets/images/qylogo33.png";
import qyLogo34 from "@/assets/images/qylogo34.png";
import qyLogo35 from "@/assets/images/qylogo35.png";
import qyLogo36 from "@/assets/images/qylogo36.png";
import qyLogo37 from "@/assets/images/qylogo37.png";
import qyLogo38 from "@/assets/images/qylogo38.png";
import qyLogo39 from "@/assets/images/qylogo39.png";
import qyLogo40 from "@/assets/images/qylogo40.png";
import { ContactUser } from "@/types/user";
import { useUpdateContactUserInfoMutation } from "@/services/api/endpoints/company";
import { ServerError } from "@/types/errors";
import { useRef } from "react";

const Company = () => {
  const columns = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 1,
    lg: 2,
    xl: 3,
  });

  const QyLogo = [
    `${qyLogo1}`,
    `${qyLogo2}`,
    `${qyLogo3}`,
    `${qyLogo4}`,
    `${qyLogo5}`,
    `${qyLogo6}`,
    `${qyLogo7}`,
    `${qyLogo8}`,
    `${qyLogo9}`,
    `${qyLogo10}`,
    `${qyLogo11}`,
    `${qyLogo12}`,
    `${qyLogo13}`,
    `${qyLogo14}`,
    `${qyLogo15}`,
    `${qyLogo16}`,
    `${qyLogo17}`,
    `${qyLogo18}`,
    `${qyLogo19}`,
    `${qyLogo20}`,
    `${qyLogo21}`,
    `${qyLogo22}`,
    `${qyLogo23}`,
    `${qyLogo24}`,
    `${qyLogo25}`,
    `${qyLogo26}`,
    `${qyLogo27}`,
    `${qyLogo28}`,
    `${qyLogo29}`,
    `${qyLogo30}`,
    `${qyLogo31}`,
    `${qyLogo32}`,
    `${qyLogo33}`,
    `${qyLogo34}`,
    `${qyLogo35}`,
    `${qyLogo36}`,
    `${qyLogo37}`,
    `${qyLogo38}`,
    `${qyLogo39}`,
    `${qyLogo40}`,
  ];

  const [updateContactUserInfo] = useUpdateContactUserInfoMutation()
  const toast = useToast();

  const form = {
    name: "",
    phone: "",
    industry: "",
    company: "",
  } as ContactUser;

  const handleValidate = (values: ContactUser) => {
    const errors: FormikErrors<{
      name: string;
      phone: string;
      industry: string;
      company: string;
    }> = {};
    if (!values.name) {
      errors.name = "姓名不能为空";
    }
    if (!values.phone) {
      errors.phone = "手机号不能为空";
    } else if (!isPhone(values.phone)) {
      errors.phone = "无效的手机号";
    }
    if (!values.industry) {
      errors.industry = "行业不能为空";
    }
    return errors;
  };

  const handleSubmit = async (values: ContactUser, {resetForm}:any) => {
    console.log(values);
    await updateContactUserInfo(values).unwrap().catch((e) => {
      toast({
        title: (e as ServerError).message,
        position: 'top',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    })

    resetForm();

  };

  return (
    <Box bgColor={"#000000"} position="relative" overflow={"hidden"}>
      <Box position={"absolute"} top="-60px" right={"40px"} maxW="38%">
        <Image src={bannerBg} maxW={"100%"} />
      </Box>
      <Box w="80%" m="0 auto" position={"relative"}>
        <Box mt="100px" color={"#FFFFFF"} fontSize="64px" fontWeight={"900"}>
          ALDGPT
          <br />
          企业级解决方案
        </Box>
        <Box w="60%" mt="30px" color={"#FFFFFF"} fontSize="30px">
          <Text display={"inline"}>为各行业提供</Text>
          <Text display={"inline"} color={"#496AE1"}>
            算力、模型、应用、部署、定制、培训
          </Text>
          <Text display={"inline"}>
            等一站式服务 成为建设行业BIM/CIM全产业链数智服务商
          </Text>
        </Box>
        <VStack align={"center"} mt="200px" mb="88px">
          <Box color={"#DCE0EB"} fontSize="36px">
            强大的核心功能
          </Box>
          <Box
            w="280px"
            h="5px"
            opacity={"0.5"}
            background="#496AE1"
            filter={"blur(4px)"}
          ></Box>
        </VStack>
        <SimpleGrid columns={columns} spacing="38px">
          <Flex
            backgroundImage={`url(${bgImg})`}
            backgroundSize="100% 100%"
            backgroundRepeat="no-repeat"
            w="100%"
            p="20px"
          >
            <Image mr="20px" src={companyImg1} />
            <Box>
              <Box color={"#FFFFFF"} fontSize="30px" mb="10px">
                秒速生图
              </Box>
              <Box color={"#CBD1DF"} fontSize="14px">
                文字描述、线稿、照片、模型，快速生成惊艳的建筑、装饰效果图
              </Box>
            </Box>
          </Flex>

          <Flex
            backgroundImage={`url(${bgImg})`}
            backgroundSize="100% 100%"
            backgroundRepeat="no-repeat"
            w="100%"
            p="20px"
          >
            <Image mr="20px" src={companyImg2} />
            <Box>
              <Box color={"#FFFFFF"} fontSize="30px" mb="10px">
                智能扩图
              </Box>
              <Box color={"#CBD1DF"} fontSize="14px">
                自动补全并延展画面边界内容，帮助场景展示更加完整自然
              </Box>
            </Box>
          </Flex>
        </SimpleGrid>
        <SimpleGrid mt="33px" columns={columns} spacing="38px">
          <Flex
            backgroundImage={`url(${bgImg})`}
            backgroundSize="100% 100%"
            backgroundRepeat="no-repeat"
            w="100%"
            p="20px"
          >
            <Image mr="20px" src={companyImg3} />
            <Box>
              <Box color={"#FFFFFF"} fontSize="30px" mb="10px">
                智能扩图
              </Box>
              <Box color={"#CBD1DF"} fontSize="14px">
                自动推演出更丰富、更精细的设计元素，让细节与整体完美融合
              </Box>
            </Box>
          </Flex>
          <Flex
            backgroundImage={`url(${bgImg})`}
            backgroundSize="100% 100%"
            backgroundRepeat="no-repeat"
            w="100%"
            p="20px"
          >
            <Image mr="20px" src={companyImg4} />
            <Box>
              <Box color={"#FFFFFF"} fontSize="30px" mb="10px">
                一键清除
              </Box>
              <Box color={"#CBD1DF"} fontSize="14px">
                快速清除图像中的瑕疵、噪点或多余元素，让设计更纯净
              </Box>
            </Box>
          </Flex>
          <Flex
            backgroundImage={`url(${bgImg})`}
            backgroundSize="100% 100%"
            backgroundRepeat="no-repeat"
            w="100%"
            p="20px"
          >
            <Image mr="20px" src={companyImg5} />
            <Box>
              <Box color={"#FFFFFF"} fontSize="30px" mb="10px">
                高清放大
              </Box>
              <Box color={"#CBD1DF"} fontSize="14px">
                低分辨率图像快速放大至高清效果，呈现震撼的设计细节和视觉效果
              </Box>
            </Box>
          </Flex>
        </SimpleGrid>
        <VStack align={"center"} mt="196px" mb="88px">
          <Box color={"#DCE0EB"} fontSize="36px">
            合作伙伴
          </Box>
          <Box
            w="166px"
            h="5px"
            opacity={"0.5"}
            background="#496AE1"
            filter={"blur(4px)"}
          ></Box>
        </VStack>
        <SimpleGrid columns={8} spacing="28px 15px">
          {QyLogo.map((item, index) => {
            return <Image key={index} src={item} />;
          })}
        </SimpleGrid>
        <Box maxW="776px" m="0 auto">
          <VStack align={"center"} mt="154px" mb="23px">
            <Box color={"#DCE0EB"} fontSize="36px">
              联系我们
            </Box>
            <Box
              w="166px"
              h="5px"
              opacity={"0.5"}
              background="#496AE1"
              filter={"blur(4px)"}
            ></Box>
          </VStack>
          <Box
            textAlign={"center"}
            m="30px auto 70px"
            color={"#FFFFFF"}
            fontSize="18px"
          >
            <Text display={"inline"}>
              填写您的业务需求，我们将为你提供1对1咨询服务<br />拨打
            </Text>
            <Text display={"inline"} color={"#496AE1"}>
              400-064-1001
            </Text>
            <Text display={"inline"}>更快获得试用机会</Text>
          </Box>
          <Box>
            <Formik
              initialValues={form}
              onSubmit={handleSubmit}
              validate={handleValidate}
            >
              {({ isSubmitting }) => (
                <Form>
                  <Box mb="30px">
                    <Field name="name">
                      {({ field, form }: any) => (
                        <FormControl
                          isInvalid={
                            form.errors.name && form.touched.name
                          }
                        >
                          <FormLabel
                            mb={"10px"}
                            fontSize={"14px"}
                            color="#FFFFFF"
                          >
                            *姓名
                          </FormLabel>
                          <Input
                            {...field}
                            fontSize={"14px"}
                            color="#8E94A9"
                            placeholder="请输入姓名"
                            border="1px solid #8E94A9"
                            h="46px"
                            // focusBorderColor="transparent"
                            // _focus={{
                            //   borderColor: "transparent",
                            // }}
                            bgColor="rgba(0, 0, 0, 0.3)"
                          />
                          <FormErrorMessage>
                            {form.errors.name}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Box>
                  <Box mb="30px">
                    <Field name="phone">
                      {({ field, form }: any) => (
                        <FormControl
                          isInvalid={form.errors.phone && form.touched.phone}
                        >
                          <FormLabel
                            mb={"10px"}
                            fontSize={"14px"}
                            color="#FFFFFF"
                          >
                            *手机号
                          </FormLabel>
                          <Input
                            {...field}
                            fontSize={"14px"}
                            color="#8E94A9"
                            placeholder="请输入手机号"
                            border="1px solid #8E94A9"
                            h="46px"
                            // focusBorderColor="transparent"
                            // _focus={{
                            //   borderColor: "transparent",
                            // }}
                            bgColor="rgba(0, 0, 0, 0.3)"
                          />
                          <FormErrorMessage>
                            {form.errors.phone}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Box>
                  <Flex mb="30px" gap="60px">
                    <Box flex={1}>
                      <Field name="industry">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.industry && form.touched.industry
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#FFFFFF"
                            >
                              *行业
                            </FormLabel>
                            <Input
                              {...field}
                              fontSize={"14px"}
                              color="#8E94A9"
                              placeholder="请输入行业"
                              border="1px solid #8E94A9"
                              h="46px"
                              // focusBorderColor="transparent"
                              // _focus={{
                              //   borderColor: "transparent",
                              // }}
                              bgColor="rgba(0, 0, 0, 0.3)"
                            />
                            <FormErrorMessage>
                              {form.errors.industry}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                    <Box flex={1}>
                      <Field name="company">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.company && form.touched.company
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#FFFFFF"
                            >
                              公司（选填）
                            </FormLabel>
                            <Input
                              {...field}
                              fontSize={"14px"}
                              color="#8E94A9"
                              placeholder="请输入公司名称（选填）"
                              border="1px solid #8E94A9"
                              h="46px"
                              // focusBorderColor="transparent"
                              // _focus={{
                              //   borderColor: "transparent",
                              // }}
                              bgColor="rgba(0, 0, 0, 0.3)"
                            />
                            <FormErrorMessage>
                              {form.errors.company}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                  </Flex>

                  <Box mt="78px" mb="100px">
                    <Button
                      borderRadius={"0px"}
                      width={"100%"}
                      height={"54px"}
                      color="#FFFFFF"
                      bgColor="#496AE1"
                      fontWeight={"normal"}
                      fontSize="18px"
                      _hover={{
                        bgColor: "#3F5BC1",
                        color: "#E6E6E6",
                      }}
                      type="submit"
                      isLoading={isSubmitting}
                    >
                      确认提交
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Company;
